import { UserRole } from '../../../../../components/RoleSwitchBar/roles';

export enum GS_DECISION {
  RETURN = 'RETURN',

  RETURN_TO_SUPERVISOR = 'RETURN_TO_SUPERVISOR',
  RETURN_TO_DSRC = 'RETURN_TO_DSRC',
  RETURN_TO_DORPGS = 'RETURN_TO_DORPGS',
  RETURN_TO_APPLICANT = 'RETURN_TO_APPLICANT',
  RETURN_TO_FRCSB = 'RETURN_TO_FRCSB',

  REJECT = 'REJECT',
  OFFER_PROVISIONED = 'OFFER_PROVISIONED',
  PANEL_SELECTION = 'PANEL_SELECTION',
  NA = 'NA',
  /** enums below are not in current use */
  TRANSFER_TO_OTHER_PANEL = 'TRANSFER_TO_OTHER_PANEL',
  ACCEPT = 'ACCEPT',
}

export const roleTextMap: Partial<Record<UserRole, string>> = {
  [UserRole.SUPERVISOR]: 'Supervisor',
  [UserRole.DRC]: 'D/SRC',
  [UserRole.FRC]: 'FRC/SB',
  [UserRole.DO_RPG_S]: 'DoRPgS',
  [UserRole.HOD_DOS]: 'HoD/DoS',
  [UserRole.GS]: 'GS',
  [UserRole.APPLICANT]: 'Applicant',
};
